<div class="main-wrapper property-view-wrapper mt-sm">
  <div class="wrapper-content">
    <ng-template #loading>
      <sp-toolbar class="mb-sm">
        <div class="sp-toolbar--item">
          <h1>{{ 'loading' | xTranslate }} {{ 'pv.title' | xTranslate }}</h1>
        </div></sp-toolbar
      >
    </ng-template>
    <ng-container *ngIf="propertyViewData() as propertyViewData; else loading">
      <sp-building-summary [building]="propertyViewData"></sp-building-summary>

      <ng-container *ngIf="propertyViewData.floors?.length > 0; else noPvData">
        <sp-toolbar class="pv-toolbar mb-xs flex-container--wrap-reverse">
          <!-- title view -->
          <div class="sp-badges sp-toolbar--item mb-sm mr-xl">
            <div class="sp-badges-list flex-container flex-container--h-alignment flex-container--wrap">
              <div class="item mb-xs">
                <div class="sp-badge available mr-xs"></div>
                <div class="sp-badge-label desc flex-container flex-container--v-alignment">
                  <div class="label">{{ 'pv.toolbar.available' | xTranslate }}</div>
                </div>
              </div>

              <div class="item mb-xs">
                <div class="sp-badge occupied mr-xs"></div>
                <div class="sp-badge-label desc flex-container flex-container--v-alignment">
                  <div class="label">{{ 'pv.toolbar.occupied' | xTranslate }}</div>
                </div>
              </div>

              <div @showHideBagde *ngIf="unaccountedToggleCtrl.value" class="item mb-xs">
                <div class="sp-badge unaccounted mr-xs"></div>
                <div class="sp-badge-label desc flex-container flex-container--v-alignment">
                  <div class="label">{{ 'pv.toolbar.unaccounted' | xTranslate }}</div>
                </div>
              </div>

              <div @showHideBagde *ngIf="nonRentableToggleCtrl.value" class="item mb-xs">
                <div class="sp-badge non-rentable mr-xs"></div>
                <div class="sp-badge-label desc flex-container flex-container--v-alignment">
                  <div class="label">{{ 'pv.toolbar.nonRentable' | xTranslate }}</div>
                </div>
              </div>
            </div>
          </div>

          <div class="sp-toolbar--item mb-sm flex-2 flex-j-end">
            <!-- Actions -->
            <!-- TODO: Refactor ACTIONS so they can be used here -->
            <!-- Manage Floors -->
            <mat-icon
              id="e2e-manage-floors-icon"
              svgIcon="building-info"
              spUpdateBuilding
              [matTooltip]="'moreInfo.manageFloorsElevators' | xTranslate"
              *ngIf="hasEditionPerms()"
              matTooltipClass="tooltip-action-icon"
            >
            </mat-icon>

            <!-- Download -->
            <ng-container *ngIf="!isPvReportDownloading(); else downloading">
              <mat-icon
                svgIcon="exit-to-app"
                matTooltipClass="tooltip-action-icon"
                [matTooltip]="'recordsSearch.download' | xTranslate"
                [matMenuTriggerFor]="
                  exportOptions()?.length === 0 || propertyViewData?.floors == null ? null : downloadPVMenu
                "
                [ngClass]="{
                  'sp-toolbar-icon--disabled': exportOptions()?.length === 0 || propertyViewData?.floors == null,
                }"
              >
              </mat-icon>
            </ng-container>
            <ng-template #downloading>
              <div class="spin-container">
                <mat-spinner diameter="17" strokeWidth="2.5"></mat-spinner>
                <span>{{ 'reports.reportActionsDownloading' | xTranslate | titlecase }}</span>
              </div>
            </ng-template>

            <mat-menu #downloadPVMenu="matMenu">
              <button
                mat-menu-item
                *ngFor="let opt of exportOptions()"
                spExport
                [id]="opt.id"
                [spExportType]="opt.exportType"
                [spExportFileType]="opt.fileType"
                [spShowDialog]="false"
                [spCanRedact]="!!propertyViewData?.canBeRedacted"
              >
                {{ opt.label | xTranslate }}
              </button>
            </mat-menu>

            <!-- Settings -->
            <mat-icon
              svgIcon="settings"
              matTooltipClass="tooltip-action-icon"
              [matTooltip]="'Stack Settings' | xTranslate"
              [matMenuTriggerFor]="propertyViewData?.floors == null ? null : settings"
              [ngClass]="{ 'sp-toolbar-icon--disabled': propertyViewData?.floors == null }"
            >
            </mat-icon>
            <mat-menu #settings="matMenu">
              <div class="eme pv-toggles">
                <mat-slide-toggle [formControl]="nonRentableToggleCtrl" (click)="$event.stopPropagation()">
                  {{ 'pv.toolbar.toggles.nonRentable' | xTranslate }}
                </mat-slide-toggle>
              </div>

              <div class="eme pv-toggles">
                <mat-slide-toggle [formControl]="unaccountedToggleCtrl" (click)="$event.stopPropagation()">
                  {{ 'pv.toolbar.toggles.unaccounted' | xTranslate }}</mat-slide-toggle
                >
              </div>

              <div class="eme pv-toggles">
                <mat-slide-toggle [formControl]="smoothToggleCtrl" (click)="$event.stopPropagation()">
                  {{ 'pv.toolbar.toggles.smooth' | xTranslate }}</mat-slide-toggle
                >
              </div>
            </mat-menu>
          </div>
        </sp-toolbar>

        <!-- PV views -->
        <div class="property-view-content-wrapper flex-container--wrap">
          <!-- Building Renderer -->
          <div
            *cbreTogglePoint="'stackingPlanPropertyViewBuilding'"
            class="pv-building-wrapper flex-container property-view flex-container--v-alignment flex-2"
          >
            <!-- Header -->
            <div class="pv-header-container"></div>

            <!-- Building Renderer -->
            <div class="building">
              <ng-container *ngFor="let f of propertyViewData?.floors">
                <div
                  *ngIf="!f.hide_floor_f"
                  class="floor floor-container"
                  id="{{ buildingFloorIdPrefix }}{{ f.floor_id }}"
                  spFloorRenderer
                  [floor]="f"
                  (click)="onClickFloor($event, f)"
                  (mouseenter)="setHoveredFloor($event, f)"
                  (mouseleave)="cleanHoveredFloor()"
                  [ngClass]="{
                    'floor-container--bordered': selectedFloor()?.floor_id === f.floor_id,
                    'floor-container--faded':
                      selectedFloor()?.floor_id != null && selectedFloor()?.floor_id !== f.floor_id,
                  }"
                ></div>
              </ng-container>
            </div>

            <!-- Building Footer Notes -->
            <div class="mt-sm mb-sm legend-container">
              <div class="item">
                <div class="item--value legend">{{ 'pv.footerNotes' | xTranslate }}</div>
              </div>
            </div>
          </div>

          <!-- Elevators Renderer -->
          <div
            class="flex-container property-view pv-elevators-wrapper"
            [style.width]="propertyViewData.building_info?.number_elevator_bank * 10 + 'px'"
          >
            <div
              *cbreTogglePoint="'stackingPlanPropertyViewElevators'"
              class="flex-container flex-container--v-alignment pv-elevators-container"
            >
              <!-- Header -->
              <div class="pv-header-container pv-header-container--border-bottom flex-container--v-alignment">
                <div class="pv-header-text pv-header-text--centered">Elev. Banks</div>
              </div>

              <div class="elevators">
                <ng-container *ngFor="let f of propertyViewData?.floors">
                  <div
                    *ngIf="!f.hide_floor_f"
                    class="floor"
                    id="{{ elevatorFloorIdPrefix }}{{ f.floor_id }}"
                    [ngClass]="{
                      'floor-container--highlighted': selectedFloor()?.floor_id === f.floor_id,
                    }"
                  >
                    <pv-elevator
                      *ngIf="!f.hide_floor_f"
                      [elevators]="f.elevators"
                      [elevatorCount]="propertyViewData.building_info?.number_elevator_bank"
                    ></pv-elevator>
                  </div>
                </ng-container>
              </div>
            </div>
          </div>

          <!-- Table Renderer -->
          <div class="flex-container property-view flex-3 pv-lease-info-wrapper">
            <div
              *cbreTogglePoint="'stackingPlanPropertyViewLeaseInfo'"
              class="flex-container flex-container--v-alignment flex-2 pv-lease-info-container"
            >
              <!-- Header -->
              <div class="lease-info pv-header-container pv-header-container--border-bottom">
                <div class="lease-info-row">
                  <div
                    *ngFor="let col of columns()"
                    class="lease-info-column pv-header-text"
                    [ngClass]="col.cssClass ?? ''"
                  >
                    {{ col.header }}
                  </div>
                </div>
              </div>

              <div class="lease-info">
                <ng-container *ngFor="let f of propertyViewData?.floors">
                  <div
                    *ngIf="!f.hide_floor_f"
                    class="lease-info-row"
                    id="{{ tableFloorRowIdPrefix }}{{ f.floor_id }}"
                    (click)="onClickFloor($event, f)"
                    (mouseenter)="setHoveredFloor($event, f)"
                    (mouseleave)="cleanHoveredFloor()"
                    [ngClass]="{
                      highlighted: getFloorStyleByRecordsType(f),
                      'floor-container--highlighted': selectedFloor()?.floor_id === f.floor_id,
                    }"
                  >
                    <div
                      *ngFor="let col of columns()"
                      class="floor lease-info-column lease-info-column--value"
                      [ngClass]="col.cssClass ?? ''"
                    >
                      <pv-cell-render
                        [floor]="f"
                        [column]="col"
                        [buildingInfo]="propertyViewData?.building_info"
                      ></pv-cell-render>
                    </div>
                  </div>
                </ng-container>
                <div class="property-view-note">
                  {{ 'pvStackOverviewNote' | xTranslate }}
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Overflow Floor Details -->
        <ng-container *ngIf="showSpaceDetails$ | async as show">
          <div
            class="space-details-wrapper"
            id="{{ spaceDetailsFloorIdPrefix }}"
            [style]="spacesDetailsCompPostion"
            [ngClass]="{
              'space-details-wrapper--freeze': spaceDetailsFreeze(),
              'space-details-wrapper--show': show,
            }"
          >
            <pv-floor-space-details></pv-floor-space-details>
          </div>
        </ng-container>
      </ng-container>

      <!-- No Data Message -->
      <ng-template #noPvData>
        <div class="pv-no-data-available">{{ 'pv.noDataAvailable' | xTranslate }}</div>
      </ng-template>
    </ng-container>
  </div>

  <!-- Last Canvased -->
  <ng-container *ngIf="lastReviewedData$ | async as lastReviewedData">
    <div class="flex-container mt-sm">
      <div class="item flex-container--h-alignment flex-center">
        <div class="item--label item--regular-label">{{ 'pv.lastReviewedDate' | xTranslate }}</div>
        <div class="item--value mr-xs item--regular-value">
          {{ lastReviewedData?.reviewedBy || '-' }}
        </div>
        <div class="item--label item--regular-label">{{ 'pv.on' | xTranslate }}</div>
        <div class="item--value item--regular-value">
          {{ lastReviewedData?.reviewedOn ? (lastReviewedData?.reviewedOn | getDateString: 'MM/DD/YYYY') : '-' }}
        </div>
      </div>
    </div>
  </ng-container>
</div>
